import React, { Component } from 'react'
import styles from './paintingBespoke.module.scss';
import { connect } from "react-redux";
import defaultImage from '../../../assets/default.png';
class PaintingBespoke extends Component<any,any> {
  render() {
    const { pageDetails } = this.props;
    const paintingDetails = {"PARTNER NAME":"","SERVICE NAME":"","PROCESS":""}
    const paintingDetails2 = {"PRODUCT NAME":"","SHADE NAME":"","CODE":""}
    return (
        <React.Fragment>
        <div className="page-image-container" style={{background:'#fff'}}>
            <div className="page-heading">{pageDetails?.name}</div>
            <div className="image-section-container">
                <img crossOrigin="anonymous" src={''} alt="" className="image-view" />
            </div>
        </div>
        <div className="details-heading">PAINTING SPECIFICATIONS</div>
        <div className={styles["tables-alignment"]} style={{margin: "15px"}}>
                <div className={styles.Table}>
                    {
                        paintingDetails && Object.keys(paintingDetails).map(key=>{
                            return(
                                <div key={key} className={styles.Row}>
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>{key.replace(/_/g, " ").toString().toUpperCase()}</p>
                                    </div>
                                    <div className={styles.Cell}>
                                        <p>{paintingDetails[key].toString().toUpperCase()}</p>
                                    </div>
                                </div>
                            );
                        })
                    }
                    
                </div> 
                <div className={styles.Table}>
                    {
                        paintingDetails2 && Object.keys(paintingDetails2).map(key=>{
                            return(
                                <div key={key} className={styles.Row}>
                                    <div className={styles['Cell']+" "+styles['headings']}>
                                        <p>{key.replace(/_/g, " ").toString().toUpperCase()}</p>
                                    </div>
                                    <div className={styles.Cell}>
                                        <p>{paintingDetails2[key].toString().toUpperCase()}</p>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>    
                <div className={styles.Table}>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']} style={{borderRight: "none"}}>
                                    <p><b>SCOPE</b></p>
                                </div>
                                <div className={styles.Cell} style={{borderLeft: "none"}}>
                                    <p></p>
                                </div>
                            </div>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>WOODWORK COVERING</p>
                                </div>
                                <div className={styles.Cell}>
                                    <p></p>
                                </div>
                            </div>
                            <div className={styles.Row}>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>POP PUNNING NEEDED ON WALL</p>
                                </div>
                                <div className={styles.Cell}>
                                    <p></p>
                                </div>
                            </div>
                    </div>   
                    <div className={styles.Table}>
                            <div className={styles.Row} style={{width:'50%'}} >
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>{"Paint Image1"}</p>
                                    {/* {
                                        wallpaperImage[0] ? <img src={wallpaperImage[0]} width="100px" height="80px" />:""
                                    } */}
                                    <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                </div>
                                <div className={styles['Cell']+" "+styles['headings']}>
                                    <p>{"Paint Image2"}</p>
                                    {/* {
                                        wallpaperImage[1] ? <img src={wallpaperImage[1]} width="100px" height="80px" />:""
                                    } */}
                                    <img alt="default Img" src={defaultImage} width="100px" height="80px" />
                                </div>
                            </div>
                    </div>
            </div>
            </React.Fragment>
    )
  }
}

export default connect(
    (state: any) => ({
        pageDetails: state.wizard.pageDetails
    }),
    {
    }
)(PaintingBespoke);